import React, { Component } from 'react';
import './../css/master.css';
import './../css/maintainQuotes.css';
import Header from './../js/header.js';
import axiosInstance from '../api/csAxios';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
//import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactImageMagnify from 'react-image-magnify';

const { IMG_TYPES } = require('./imgType');

var sortVal = "";
var httpURL = '';
var queryString = require('querystring');
var lstQuotes = [];
var lstQuoteDesigns = [];
var lstQuoteWeaver = [];
var lstDesignColor = [];
var lstCompanyPO = [];
var wvrDesign = [];
var lstQuotesStatus = [];
var url = '';
var urlFlag = '';
var COL_QTT_QUOTEID = 'td:eq(0)';
var COL_QTT_DESIGNID = 'td:eq(1)';
var COL_QTT_QTDESIGNID = 'td:eq(5)';
var COL_QTT_DESIGNCOLOR = 'td:eq(6)';
var COL_QTT_PARENTCOMPID = 'td:eq(7)';
var COL_QTT_PARENTCOMP = 'td:eq(8)';
var COL_QTT_BPOID = 'td:eq(9)';
var COL_QTT_BPO = 'td:eq(10)';
var COL_QTT_BPOSTYLEID = 'td:eq(11)';
var COL_QTT_STYLE = 'td:eq(12)';
var COL_QTT_COLOR = 'td:eq(13)';
var COL_QTT_DELIVERYDT = 'td:eq(14)';
var COL_QTT_BUYERQUALITY = 'td:eq(15)';


var COL_BPT_PARENTCOMPID = 'td:eq(0)';
var COL_BPT_PARENTCOMP = 'td:eq(1)';
var COL_BPT_BPOID = 'td:eq(2)';
var COL_BPT_BPOSTYLEID = 'td:eq(3)';
var COL_BPT_BPONO = 'td:eq(4)';
var COL_BPT_SEASON = 'td:eq(5)';
var COL_BPT_DELIVERYDT = 'td:eq(6)';
var COL_BPT_BUYERQUALITY = 'td:eq(7)';
var COL_BPT_STYLE = 'td:eq(8)';
var COL_BPT_COLOR = 'td:eq(9)';
var COL_BPT_QUALITYID = 'td:eq(10)';
var COL_BPT_QUALITY = 'td:eq(11)';
var COL_BPT_LENGTH = 'td:eq(12)';
var COL_BPT_WIDTH = 'td:eq(13)';
var COL_BPT_BUFFERDAYS = 'td:eq(14)';
var COL_BPT_CONSTRUCTION = 'td:eq(15)';
var COL_BPT_YARNCOUNT = 'td:eq(16)';

var flg = '';
var lstCity = [];
var quoteId = 0;
var lstColorId = [];
var lstWeaverId = [];
var lstConstruction = [];
var lstYarnCount = [];
var lstWidth = [];
var lstQuality = [];

class MaintainQuotes extends Component {
	constructor(props) {
		super(props);
		this.state = {
			quotes: [],
			designQuoteList: [],
			weaverQuoteList: [],
			designColor: [],
			city: [],
			lstQuotesStatus: [],
			flg: true,
			expectedDate: null,
			startDate: null,
			endDate: null,
			ppsDt: null,
			minDate: new Date(),
			loader: 'none',
			opacity: 1,
			width: '97.6%',
			width1: '97.6%',
			width2: '97.6%',
			width3: '96.2%',
			width4: '96.2%',
			src: require('./../images/blank.png'),
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleChange1 = this.handleChange1.bind(this);
		this.handleChange2 = this.handleChange2.bind(this);
		this.handleChangePpsDt = this.handleChangePpsDt.bind(this);
	}

	handleChange(date) {
		this.setState({
			expectedDate: date
		});
	}
	handleChange1(date) {
		this.setState({
			startDate: date
		});
	}

	handleChange2(date) {
		this.setState({
			endDate: date
		});
	}
	handleChangePpsDt(date) {
		this.setState({
			ppsDt: date
		});
	}

	async componentDidMount() {
		$('#filterStatusCmb').prepend($("<option> </option>").val(0).html('Status'));

		this.setState({ loader: 'block', opacity: 0.5 });
		await axiosInstance.get(httpURL + '/a/mst/cons/list', {
			withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				lstConstruction = response.data.lstConstruction;
				this.fillConstructionCmb();
			}
			else {
				toast.error(response.data.SvcMsg);
			}
		}).catch((error) => {
			toast.error("Service failed " + error);
		});

		await axiosInstance.get(httpURL + '/a/mst/yarn/list', {
			withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				lstYarnCount = response.data.lstYarnCount;
				this.fillYarnCountCmb();
			}
			else {
				toast.error(response.data.SvcMsg);
			}

		}).catch((error) => {
			toast.error("Service failed " + error);
		});

		await axiosInstance.get(httpURL + '/a/mst/wdh/list', {
			withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				lstWidth = response.data.lstWidth;
				this.fillWidthCmb();
			}
			else {
				toast.error(response.data.SvcMsg);
			}
		}).catch((error) => {
			toast.error("Service failed " + error);
		});

		await axiosInstance.get(httpURL + '/a/mst/qlty/list', {
			withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				lstQuality = response.data.lstQuality;
				this.fillQualityCmb();
			}
			else {
				toast.error(response.data.SvcMsg);
			}

		}).catch((error) => {
			toast.error("Service failed " + error);
		});

		var url_string = window.location.href;
		urlFlag = new URL(url_string);
		var flag = urlFlag.searchParams.get("flag");
		if (flag == 'poScreen') {
			url = this.props.location.state.detail;
			this.openDesignPopup();
			flg = 'poScreen';
			$('#inp_company').val(url.parentComp);
			$('#inp_buyerPo').val(url.bpoNo);
			$('#inp_style').val(url.style);
			$('#inp_length').val(url.length == 0 ? '' : url.length);
			$('#inp_csLength').val(url.length == 0 ? '' : url.length);
			$('#inp_color').val(url.color);
			$('#inp_deliveryDt').val(url.deliveryDt);
			$('#inp_quality').val(url.buyerQuality);
			$('#inp_construction').val(url.constructionId);
			$('#inp_yarnCount').val(url.yarnCountId);
			$('#inp_csWidth').val(url.widthId);
			$('#inp_csQuality').val(url.qualityId);

			var expDate = url.deliveryDt;
			expDate = expDate.split('-');
			expDate = new Date(expDate[2], expDate[1] - 1, expDate[0]);
			expDate = expDate.setDate(expDate.getDate() - url.bufferDays);
			expDate = new Date(expDate);

			this.setState({
				expectedDate: expDate,
			}, () => {
				var date1 = new Date();
				if (expDate < date1) {
					this.setState({
						minDate: expDate,
					})
				} else {
					this.setState({
						minDate: date1,
					})
				}
			});
		}

		axiosInstance.get(httpURL + '/a/quo/listQuo',
			{ withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === "Success") {
				if (response.data.SvcMsg === 'No Quotes are present. Add Some') {
					toast.success('No Quotes are present. Add Some');
					lstQuotes = [];
				} else {
					this.setState({
						quotes: response.data.lstQuotes,
						lstQuotesStatus: response.data.lstQuotesStatus,
					});
					lstQuotes = this.state.quotes;
					lstQuotesStatus = this.state.lstQuotesStatus;
					this.setQuotesTable();
					this.fillStatusCmb();
				}
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.CSURL;
					return false;
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((e) => {
			toast.error("Service failed " + e);
		});

		this.handleResize();
		window.addEventListener("load", this.handleResize);
		window.addEventListener("resize", this.handleResize);

		var date = new Date();
		var startDate = date.setDate(date.getDate() - 30)
		this.setState({
			startDate: new Date(startDate),
		});
		startDate = new Date(startDate);
		var endDate = startDate.setDate(startDate.getDate() + 90);
		this.setState({
			endDate: new Date(endDate),
		});
	}

	requestNewQuotes = () => {
		flg = 'newQuotes';
		this.openDesignPopup();
	}
	handleResize = () => {
		var width = ($('.tableLayout1').parent().width()) - 17;
		var width1 = ($('.tableLayout2').parent().width()) - 17;
		var width2 = ($('.tableLayout3').parent().width()) - 17;
		var width3 = ($('.tableLayout4').parent().width()) - 17;
		var width4 = ($('.tableLayout5').parent().width()) - 17;
		this.setState({ width: width, width1: width1, width2: width2, width3: width3, width4: width4 });
	}

	fillConstructionCmb() {
		$('#inp_construction').empty();
		$('#inp_construction').prepend($("<option> </option>").val(0).html('Construction'));
		for (var i = 0; i < lstConstruction.length; i++) {
			var constructionId = lstConstruction[i].constructionId;
			var construction = lstConstruction[i].construction;
			$('#inp_construction').append($("<option> </option>").val(constructionId).html(construction));
		}
	}

	fillYarnCountCmb() {
		$('#inp_yarnCount').empty();
		$('#inp_yarnCount').prepend($("<option> </option>").val(0).html('Yarn Count'));
		for (var i = 0; i < lstYarnCount.length; i++) {
			var yarnCountId = lstYarnCount[i].yarnCountId;
			var yarnCount = lstYarnCount[i].yarnCount;
			$('#inp_yarnCount').append($("<option> </option>").val(yarnCountId).html(yarnCount));
		}
	}

	fillWidthCmb() {
		$('#inp_csWidth').empty();
		$('#inp_csWidth').prepend($("<option> </option>").val(0).html('Width'));
		for (var i = 0; i < lstWidth.length; i++) {
			var widthId = lstWidth[i].widthId;
			var width = lstWidth[i].width;
			$('#inp_csWidth').append($("<option> </option>").val(widthId).html(width));
		}
	}

	fillQualityCmb() {
		$('#inp_csQuality').empty();
		$('#inp_csQuality').prepend($("<option> </option>").val(0).html('Quality Name'));
		for (var i = 0; i < lstQuality.length; i++) {
			var qualityId = lstQuality[i].qualityId;
			var quality = lstQuality[i].quality;
			$('#inp_csQuality').append($("<option> </option>").val(qualityId).html(quality));
		}
	}
	fillStatusCmb = () => {
		$('#filterStatusCmb').empty();
		$('#filterStatusCmb').prepend($("<option> </option>").val(0).html('Status'));
		for (var i = 0; i < lstQuotesStatus.length; i++) {
			var status = lstQuotesStatus[i];
			$('#filterStatusCmb').append($("<option> </option>").val(i + 1).html(status));
		}
	}

	setQuotesTable = () => {
		$('#quoteTableBody tr').remove();
		var table = document.getElementById('quoteTable');
		var tbody = document.getElementById('quoteTableBody');
		var filterDesignColor = $('#filterDesignColor').val().trim().toLowerCase();
		var filterStatus = $('#filterStatusCmb').find('option:selected').text();

		for (var i = 0; i < lstQuotes.length; i++) {
			var quoteId = lstQuotes[i].quoteId;
			var designId = lstQuotes[i].designId;
			var quoteDesignId = lstQuotes[i].quoteDesignId;
			var designNoColor = lstQuotes[i].designNoColor;
			var parentCompId = lstQuotes[i].parentCompId;
			var parentComp = lstQuotes[i].parentComp;
			var bpoId = lstQuotes[i].bpoId;
			var bpoNo = lstQuotes[i].bpoNo;
			var bpoStyleId = lstQuotes[i].bpoStyleId;
			var style = lstQuotes[i].style;
			var color = lstQuotes[i].color;
			var deliveryDt = lstQuotes[i].deliveryDt;
			var buyerQuality = lstQuotes[i].buyerQuality;
			var status = lstQuotes[i].status;
			var createdOn = lstQuotes[i].createdOn;
			var requestedOn = lstQuotes[i].requestedOn;

			var row = document.createElement('tr');
			row.id = 'quoteTable' + quoteId;

			if (designNoColor.toLowerCase().indexOf(filterDesignColor) === -1)
				continue;

			if (filterStatus !== "Status" && status !== filterStatus)
				continue;

			this.addTD(row, quoteId, 'txtright');
			this.addTD(row, designId, 'txtright no-display');
			this.addTD(row, createdOn, 'text-center');
			this.addTD(row, requestedOn, 'text-center');
			this.addTD(row, style, '');
			this.addTD(row, quoteDesignId, 'no-display');
			this.addTD(row, designNoColor, '');
			this.addTD(row, parentCompId, 'no-display');
			this.addTD(row, parentComp, '');
			this.addTD(row, bpoId, 'no-display');
			this.addTD(row, bpoNo, '');
			this.addTD(row, bpoStyleId, 'no-display');
			this.addTD(row, style, '');
			this.addTD(row, color, '');
			this.addTD(row, deliveryDt, 'no-display');
			this.addTD(row, buyerQuality, 'no-display');
			this.addTD(row, status, '');
			this.addTDEdit(row, 'glyphicon glyphicon-option-vertical', 'text-center');

			tbody.append(row);
		}
		table.append(tbody);
	}

	hideSlider(e) {
		e.preventDefault();
		$('.cd-panel').removeClass('is-visible');
		$('.designPopup1').hide();
	}

	addDesignForm = () => {
		flg = 'addDsgn';
		this.openDesignPopup();
	}

	editDesignForm = () => {
		flg = 'editDsgn';
		this.openDesignPopup();
	}

	addTD(row, val, classname) {
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}

	addTDEdit = (row, val, classname) => {
		var cell = document.createElement('td');
		var span = document.createElement('span');
		cell.className = classname;
		span.className = val;
		span.style.position = 'relative';
		span.style.cursor = 'pointer';

		var ul = document.createElement('ul');
		ul.className = 'ulStyle1';

		var li1 = document.createElement('li');
		var li2 = document.createElement('li');
		var li3 = document.createElement('li');

		li1.innerHTML = 'Add Design';
		li2.innerHTML = 'Edit Design';
		li3.innerHTML = 'Request Quote';

		li1.onclick = () => {
			$('.designPopup').show();
			this.addDesignForm();
		};

		li2.onclick = () => {
			$('.designPopup').show();
			this.editDesignForm();
		};

		li3.onclick = () => {
			$('.cd-panel').addClass('is-visible');
			var quoteId = $('#quoteTableBody tr.selected').find(COL_QTT_QUOTEID).text();
			var designId = $('#quoteTableBody tr.selected').find(COL_QTT_DESIGNID).text();
			$('#inp_quoteId').val(quoteId);
			flg = 'rqstQuote';
			this.getQuoteDesign(quoteId, designId);
			$('.designPopup1').css("display", "block");
			this.handleResize();
		};

		ul.append(li1);
		ul.append(li2);
		ul.append(li3);

		span.onclick = (e) => {
			$(ul).toggle();
			$(e.target.closest('tr')).siblings().find('span ul').hide();
			$(e.target.closest('tr')).addClass('selected').siblings().removeClass('selected');
		};

		span.append(ul);
		cell.append(span);
		row.append(cell);
	}

	addTDEdit1(row, val, classname) {
		var cell = document.createElement('td');
		cell.className = classname;
		var span = document.createElement('span');
		span.className = val;
		span.style.cursor = 'pointer';
		span.addEventListener('click', this.deleteDispatch);
		cell.append(span);
		row.append(cell);
	}

	deleteDispatch = (e) => {
		var x = window.confirm('Are you sure you want to delete this QuoteId?');
		if (x) {
			var quoteId = $('#inp_quoteId').val();
			//var quoteId = $(e.target).closest('tr').find(COL_QTT_QUOTEID).text();
			var designId = $(e.target).closest('tr').find(COL_QTT_QUOTEID).text();
			var dlt = { designId, quoteId }

			this.setState({ loader: 'block', opacity: 0.5 });
			axiosInstance.post(httpURL + '/a/quo/dltQuoDsn',
				queryString.stringify({ 'dlt': JSON.stringify(dlt) }), { withCredentials: true }
			).then((response) => {
				if (response.data.SvcStatus === 'Success') {
					toast.success(response.data.SvcMsg);
					$(e.target).closest('tr').remove();
					$('#quoteTableBody tr.selected').remove();

				}
				else {
					toast.error(response.data.SvcMsg);
					if (response.data.SvcMsg == 'You are not logged in') {
						window.location.href = window.WVRURL;
						return false;
					}
				}
				this.setState({ loader: 'none', opacity: 1 });
			}).catch((error) => {
				toast.error("Service failed " + error);
			});
		}
	}

	addTDImage(row, val, classname) {
		var date = new Date();
		var cell = document.createElement('td');
		cell.className = classname;
		var img = document.createElement('img');
		var lazyload = document.createElement('LazyLoad');
		img.style.width = '20px';
		img.style.height = '20px';
		if (val == '') {
			img.src = require("../images/logo.png");
		} else if (val != null) {
			img.src = window.httpURL + "/a/mst/dsn/getImage?img=" + val + '&imgType=' + IMG_TYPES.THUMB;
		} else {
			img.src = require("../images/logo.png");
		}
		lazyload.append(img);
		cell.append(lazyload);

		row.append(cell);
	}

	addTDCbxStatus(row, status, classname) {
		var cell = document.createElement('td');
		cell.className = classname;
		var cbx = document.createElement('input');
		cbx.type = 'checkbox';
		cbx.setAttribute('disabled', true);
		if (status === true) {
			cbx.setAttribute('checked', 'checked');
		}
		cell.append(cbx);
		row.append(cell);
	}


	getIdxQuote(quoteId) {
		for (var i = 0; i < lstQuotes.length; i++) {
			if (lstQuotes[i].quoteId == quoteId) {
				return i;
			}
		}
		return -1;
	}

	highlightRow(table, id) {
		$('#' + table + ' tr').each(function () {
			var quoteId = $(this).find(COL_QTT_QUOTEID).text();
			if (quoteId == id) {
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}

	highlightRowQuoteDesignId(table, id) {
		$('#' + table + ' tr').each(function () {
			var quoteDesignId = $(this).find(COL_QTT_QTDESIGNID).text();
			if (quoteDesignId == id) {
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}

	highlightRow1(table, id) {
		$('#' + table + ' tr').each(function () {
			var designId = $(this).find('td:eq(0)').text();
			if (designId == id) {
				$(this).trigger('click');
			}
		});
	}

	openIpoPopup = () => {
		var weaver = '';
		var count = 0;
		var x = false;
		var y = false;
		var t = false;
		var i = false;
		var z = false;
		var designNoColor = '';
		var designColor = '';
		$('#quoteDesignTableBody tr').each(function () {
			if ($(this).find('input[type="checkbox"]').prop('checked')) {
				var expectedDt = $(this).find('td:eq(3)').text();
				var bpoId = $(this).find('td:eq(8)').text();
				designNoColor = $(this).find('td:eq(2)').text();
				if (expectedDt == '') {
					y = true;
					return false;
				}
				if (bpoId == 0) {
					t = true;
					return false;
				}
			}
		});

		if (y) {
			toast.warning('Expected date is not available for the selected design ' + '"' + designNoColor + '"');
			return false;
		}
		if (t) {
			toast.warning('Buyer po is  not available for the selected design ' + '"' + designNoColor + '"');
			return false;
		}

		$('#quoteWeaverTableBody tr').each((index, e) => {
			if ($(e).find('input[type="checkbox"]').prop('checked') == true) {
				count++;
				var designId = $(e).attr('class');
				var weaverId = $(e).find('td:last-child()').text();
				var constrution = $(e).find('td:nth-last-child(9)').text();
				var ipoId = $(e).find('td:nth-last-child(6)').text();
				designColor = $(e).attr('data-designcolor');

				if (constrution == '') {
					z = true;
					return false;
				}
				if (ipoId != 0) {
					i = true;
					return false;
				}
				if (weaver != '' && weaver != weaverId) {
					x = true;
				}
				weaver = weaverId;
			}
		});

		if (count == 0) {
			toast.warning('Please select atleast one weaver');
			return false;
		}

		if (i) {
			toast.warning('Ipo is already available for the selected design ' + '"' + designColor + '"');
			return false;
		}

		if (z) {
			toast.warning('Weaver not responded yet for this- ' + '"' + designColor + '"');
			return false;
		}

		if (x) {
			toast.warning('Please select same weaver');
			return false;
		}

		$('.ipoPopup').show();
		$('.main, .cd-panel').addClass('addOpacity');
		$('#ipoForm').trigger('reset');
	}

	openDesignPopup = () => {
		//var quoteId  = $('#inp_quoteId').val();
		//var quoteId 	= $('#quoteTableBody tr.selected').find(COL_QTT_QUOTEID).text();
		var date = new Date();
		$('#designNoColor').val("");
		$('.designPopup').show();
		$('#quoteDesignPopup').show().siblings().hide();
		$('.main, .cd-panel').addClass('addOpacity');
		$('#machineTableBody1 tr').remove();
		$('#quoteDesignForm').trigger('reset');

		this.setState({
			minDate: date,
			expectedDate: null,
			src: require('./../images/blank.png'),
			loader: 'block',
			opacity: 0.5,
		});

		axiosInstance.get(httpURL + '/a/mst/dsn/list', {
			withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				this.setState({
					designNoColor: response.data.lstDesigns,
				})
				lstDesignColor = this.state.designNoColor;
				this.setDesignColorTable();
				if (flg == 'poScreen') {
					$('#addEditBpo').attr('disabled', true);
					$('#designColorTableBody tr').each(function () {
						if ($(this).find('td:eq(0)').text() == url.designId) {
							$(this).trigger('click');
							$('.designColorTableDiv').css('pointerEvents', 'none');
						}
					});
					//this.highlightRow1('designColorTableBody', url.designId);
				} else if (flg == 'addDsgn' || flg == 'rqstQuote') {
					$('.designColorTableDiv').css('pointerEvents', 'auto');
					$('#addEditBpo').attr('disabled', true);
					var quoteId = $('#quoteTableBody tr.selected').find(COL_QTT_QUOTEID).text();
					var bpoData = this.getBpoData(quoteId);
					if (bpoData != -1) {
						$('#inp_company').val(bpoData.parentComp);
						$('#inp_buyerPo').val(bpoData.bpoNo);
						$('#inp_style').val(bpoData.style);
						$('#inp_length').val(bpoData.length == 0 ? "" : bpoData.length);
						$('#inp_color').val(bpoData.color);
						$('#inp_quality').val(bpoData.buyerQuality);
						$('#inp_deliveryDt').val(bpoData.deliveryDt);
					}
				} else if (flg == 'editDsgn') {
					var designId = $('#quoteTableBody tr.selected').find(COL_QTT_DESIGNID).text();
					$('#addEditBpo').attr('disabled', false);
					$('#designColorTableBody tr').each(function () {
						if ($(this).find('td:eq(0)').text() == designId) {
							$(this).trigger('click');
							$('.designColorTableDiv').css('pointerEvents', 'none');
						}
					});
				} else {
					$('#addEditBpo').attr('disabled', true);
					$('.designColorTableDiv').css('pointerEvents', 'auto');
				}
			}
			else {
				toast.error(response.data.SvcMsg);
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	setDesignColorTable = () => {
		$('#designColorTableBody tr').remove();
		var table = document.getElementById('designColorTable');
		var tbody = document.getElementById('designColorTableBody');
		var filterDesignColor = $('#designNoColor').val().toLowerCase();
		for (var i = 0; i < lstDesignColor.length; i++) {
			var id = lstDesignColor[i].designId;
			var designColor = lstDesignColor[i].designNoColor;
			var designImage = lstDesignColor[i].imgPath;
			var updatedOn = lstDesignColor[i].updatedOn;

			var row = document.createElement('tr');
			row.id = id;

			row.onclick = (e) => {
				console.log("row clicked");
				$($(e.target).closest('tr')).addClass('selected').siblings().removeClass('selected');
				var designId = $('#designColorTableBody tr.selected').find('td:eq(0)').text();
				var quoteDesignId = $('#quoteTableBody tr.selected').find(COL_QTT_QTDESIGNID).text();
				this.setDesignColorForm(designId, quoteDesignId);
			}

			if (designColor.toLowerCase().indexOf(filterDesignColor) == -1)
				continue;

			this.addTD(row, id, 'text-right');
			this.addTD(row, designColor, '');
			this.addTDImage(row, designImage, 'text-center');
			this.addTD(row, updatedOn, 'text-center');

			tbody.append(row);
		}
		table.append(tbody);
	}

	setDesignColorForm = (designId, quoteDesignId) => {
		console.log("setDesignColorForm() called");
		var date = new Date();
		var designColorData = this.getdesignColorData(designId);

		if (flg == 'editDsgn') {
			var designColorFormData = this.getdesignColorFormData(quoteDesignId);
			if (designColorFormData != -1) {
				$('#inp_construction').val(designColorFormData.constructionId);
				$('#inp_yarnCount').val(designColorFormData.yarnCountId);
				$('#inp_csLength').val(designColorFormData.csLength == 0 ? '' : designColorFormData.csLength);
				$('#inp_csWidth').val(designColorFormData.csWidthId);
				$('#inp_notes').val(designColorFormData.notes);
				$('#inp_company').val(designColorFormData.parentComp);
				$('#inp_buyerPo').val(designColorFormData.bpoNo);
				$('#inp_style').val(designColorFormData.style);
				$('#inp_length').val(designColorFormData.length == 0 ? '' : designColorFormData.length);
				$('#inp_color').val(designColorFormData.color);
				$('#inp_deliveryDt').val(designColorFormData.deliveryDt);
				$('#inp_quality').val(designColorFormData.buyerQuality);
				$('#inp_csQuality').val(designColorFormData.qualityId);

				if (designColorFormData.expectedDt == '' || designColorFormData.expectedDt == null) {
					this.setState({
						minDate: date,
						expectedDate: null,
					});
				} else {
					var date1 = designColorFormData.expectedDt;
					date1 = date1.split('-');
					var selected = new Date(date1[2], date1[1] - 1, date1[0]);

					var setDate = date1.reverse().join();
					setDate = setDate.replace(/,/g, '-');
					var expectedDate = new Date(setDate);

					this.setState({
						expectedDate: expectedDate,
					}, () => {
						if (selected < date) {
							this.setState({
								minDate: selected,
							});
						} else {
							this.setState({
								minDate: date,
							})
						}
					});
				}
			}
		}




		$('#machineTableBody tr').find($('input[type=checkbox]').attr('checked', false));
		console.log(designColorData);
		if (designColorData !== -1) {
			console.log(designColorData.imgPath);
			if (designColorData.imgPath == '') {
				this.setState({ src: require('./../images/blank.png') });
			} else if (designColorData.imgPath != null) {
				console.log(window.httpURL + "/a/mst/dsn/getImage?img=" + designColorData.imgPath + '&imgType=' + IMG_TYPES.THUMB);
				this.setState({ src: window.httpURL + "/a/mst/dsn/getImage?img=" + designColorData.imgPath + '&imgType=' + IMG_TYPES.THUMB });
			} else {
				this.setState({ src: require('./../images/blank.png') });
			}
		}
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.get(httpURL + '/a/mst/dsn/listDesignMachineType', {
			params: {
				'designId': designId,
			},
			withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				var machineType = response.data.lstMachines;
				this.setMachineTable(machineType);
			}
			else {
				toast.error(response.data.SvcMsg);
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	getdesignColorData(designId) {
		for (var i = 0; i < lstDesignColor.length; i++) {
			if (designId == lstDesignColor[i].designId) {
				return lstDesignColor[i];
			}
		}
		return -1;
	}

	getdesignColorFormData(quoteDesignId) {
		for (var i = 0; i < lstQuotes.length; i++) {
			if (quoteDesignId == lstQuotes[i].quoteDesignId) {
				return lstQuotes[i];
			}
		}
		return -1;
	}

	getdesignDesData(quoteDesignId) {
		for (var i = 0; i < lstQuoteDesigns.length; i++) {
			if (quoteDesignId == lstQuoteDesigns[i].quoteDesignId) {
				return lstQuoteDesigns[i];
			}
		}
		return -1;
	}
	getBpoData(quoteId) {
		for (var i = 0; i < lstQuotes.length; i++) {
			if (quoteId == lstQuotes[i].quoteId) {
				return lstQuotes[i];
			}
		}
		return -1;
	}

	setMachineQuote = () => {
		var designId = $('#quoteDesignTableBody tr.selected').find('td:eq(0)').text();
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.get(httpURL + '/a/mst/dsn/listDesignMachineType', {
			params: {
				'designId': designId,
			},
			withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				var machineType = response.data.lstMachines;
				this.setMachineTable1(machineType);
				//var machineTypeId 	= lstMachine[i].machineTypeId;
			}
			else {
				toast.error(response.data.SvcMsg);
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}



	setMachineTable = (lstMachine) => {
		$('#machineTableBody1 tr').remove();
		var table = document.getElementById('machineTable1');
		var tbody = document.getElementById('machineTableBody1');

		for (var i = 0; i < lstMachine.length; i++) {
			var machineTypeId = lstMachine[i].machineTypeId;
			var machineType = lstMachine[i].machineType;
			var capacity = lstMachine[i].capacity;
			var selected = lstMachine[i].selected;

			var row = document.createElement('tr');
			row.id = machineTypeId;

			this.addTD(row, machineTypeId, 'no-display');
			this.addTD(row, machineType, '');
			this.addTD(row, capacity, 'text-right');
			this.addTDCbxStatus(row, selected, 'text-center');

			tbody.append(row);
		}
		table.append(tbody);
	}
	setMachineTable1 = (lstMachine) => {
		$('#machineTableBody tr').remove();
		var table = document.getElementById('machineTable');
		var tbody = document.getElementById('machineTableBody');

		for (var i = 0; i < lstMachine.length; i++) {
			var machineTypeId = lstMachine[i].machineTypeId;
			var machineType = lstMachine[i].machineType;
			var capacity = lstMachine[i].capacity;
			var selected = lstMachine[i].selected;
			this.highlightRow1('quoteWeaverTableBody', machineTypeId);

			var row = document.createElement('tr');
			row.id = machineTypeId;

			this.addTD(row, machineTypeId, 'no-display');
			this.addTD(row, machineType, '');
			this.addTD(row, capacity, 'text-right');
			this.addTDCbxStatus(row, selected, 'text-center');

			tbody.append(row);
		}
		table.append(tbody);
	}

	selectDesignColor = () => {
		var quoDsn = {};
		var designId = '';
		var quoteId = '';
		var quoteDesignId = 0;
		var bpoId = '';
		var bpoNo = '';
		var parentCompId = '';
		var parentComp = '';
		var bpoStyleId = '';
		var style = '';
		var color = '';
		var designNoColor = '';
		var deliveryDt = '';
		var buyerQuality = '';
		var qualityId = 0;
		var quality = '';


		if (flg == 'rqstQuote') {
			quoteId = $('#inp_quoteId').val();
			designId = $('#designColorTableBody tr.selected').find('td:eq(0)').text();
			parentCompId = $('#quoteTableBody tr.selected').find(COL_QTT_PARENTCOMPID).text();
			parentComp = $('#quoteTableBody tr.selected').find(COL_QTT_PARENTCOMP).text();
			bpoId = $('#quoteTableBody tr.selected').find(COL_QTT_BPOID).text();
			bpoStyleId = $('#quoteTableBody tr.selected').find(COL_QTT_BPOSTYLEID).text();
		}
		if (flg == 'newQuotes') {
			quoteId = 0;
			designId = $('#designColorTableBody tr.selected').find('td:eq(0)').text();
		}
		if (flg == 'addDsgn') {
			quoteId = $('#quoteTableBody tr.selected').find(COL_QTT_QUOTEID).text();
			designId = $('#designColorTableBody tr.selected').find('td:eq(0)').text();
			parentCompId = $('#quoteTableBody tr.selected').find(COL_QTT_PARENTCOMPID).text();
			parentComp = $('#quoteTableBody tr.selected').find(COL_QTT_PARENTCOMP).text();
			bpoId = $('#quoteTableBody tr.selected').find(COL_QTT_BPOID).text();
			bpoStyleId = $('#quoteTableBody tr.selected').find(COL_QTT_BPOSTYLEID).text();
			deliveryDt = $('#quoteTableBody tr.selected').find(COL_QTT_DELIVERYDT).text();
			buyerQuality = $('#quoteTableBody tr.selected').find(COL_QTT_BUYERQUALITY).text();
		}
		if (flg == 'editDsgn') {
			quoteId = $('#quoteTableBody tr.selected').find(COL_QTT_QUOTEID).text();
			designId = $('#designColorTableBody tr.selected').find('td:eq(0)').text();
			quoteDesignId = $('#quoteTableBody tr.selected').find(COL_QTT_QTDESIGNID).text();
			parentCompId = $('#quoteTableBody tr.selected').find(COL_QTT_PARENTCOMPID).text();
			parentComp = $('#quoteTableBody tr.selected').find(COL_QTT_PARENTCOMP).text();
			bpoId = $('#quoteTableBody tr.selected').find(COL_QTT_BPOID).text();
			bpoStyleId = $('#quoteTableBody tr.selected').find(COL_QTT_BPOSTYLEID).text();
			deliveryDt = $('#quoteTableBody tr.selected').find(COL_QTT_DELIVERYDT).text();
			buyerQuality = $('#quoteTableBody tr.selected').find(COL_QTT_BUYERQUALITY).text();
		}
		if (flg == 'poScreen') {
			quoteId = 0;
			designId = $('#designColorTableBody tr.selected').find('td:eq(0)').text();
			parentCompId = url.parentCompId;
			parentComp = url.parentComp;
			bpoId = url.bpoId;
			bpoStyleId = url.bpoStyleId;
			deliveryDt = url.deliveryDt;
			buyerQuality = url.buyerQuality;
		}

		if (designId == '') {
			toast.warning('Please select any design');
			return false;
		}

		var bpoNo = $('#inp_buyerPo').val();
		var style = $('#inp_style').val();
		var color = $('#inp_color').val();
		var length = $('#inp_length').val();
		var deliveryDt = $('#inp_deliveryDt').val();
		var constructionId = $('#inp_construction').find('option:selected').val();
		var construction = $('#inp_construction').find('option:selected').text();
		var yarnCountId = $('#inp_yarnCount').find('option:selected').val();
		var yarnCount = $('#inp_yarnCount').find('option:selected').text();
		var csLength = $('#inp_csLength').val();
		var csWidthId = $('#inp_csWidth').find('option:selected').val();
		var csWidth = $('#inp_csWidth').find('option:selected').text();
		var qualityId = $('#inp_csQuality').find('option:selected').val();
		var quality = $('#inp_csQuality').find('option:selected').text();
		var buyerQuality = $('#inp_quality').val();
		var expectedDt = $('#inp_expectedDt').val();
		expectedDt = expectedDt == '' ? null : expectedDt;
		var notes = $('#inp_notes').val();

		quoDsn.quoteDesignId = quoteDesignId;
		quoDsn.quoteId = quoteId;
		quoDsn.designId = designId;
		quoDsn.parentCompId = parentCompId;
		quoDsn.bpoId = bpoId;
		quoDsn.length = length;
		quoDsn.bpoStyleId = bpoStyleId;
		quoDsn.constructionId = constructionId;
		quoDsn.yarnCountId = yarnCountId;
		quoDsn.csLength = csLength;
		quoDsn.csWidthId = csWidthId;
		quoDsn.qualityId = qualityId;
		quoDsn.expectedDt = expectedDt;
		quoDsn.notes = notes;
		console.log('quoDsn = ' + JSON.stringify(quoDsn));
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.post(httpURL + '/a/quo/saveQuoDsn',
			queryString.stringify({ 'quoDsn': JSON.stringify(quoDsn) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === "Success") {
				toast.success(response.data.SvcMsg);
				var quoteId = response.data.quoteId;
				var quoteDesignId = response.data.quoteDesignId;
				var designNoColor = $('#designColorTableBody tr.selected').find('td:eq(1)').text();

				quoDsn.quoteId = quoteId;
				quoDsn.quoteDesignId = quoteDesignId;
				quoDsn.bpoNo = bpoNo;
				quoDsn.style = style;
				quoDsn.color = color;
				quoDsn.parentComp = parentComp;
				quoDsn.designNoColor = designNoColor;
				quoDsn.deliveryDt = deliveryDt;
				quoDsn.quality = quality;
				quoDsn.yarnCount = yarnCount;
				quoDsn.csWidth = csWidth;
				quoDsn.buyerQuality = buyerQuality;

				if (flg == 'poScreen') {
					lstQuotes.push(quoDsn);
					this.setQuotesTable();
					this.highlightRow('quoteTableBody', quoteId);
				} else if (flg == 'newQuotes' || flg == 'addDsgn') {
					lstQuotes.push(quoDsn);
					this.setQuotesTable();
					this.highlightRow('quoteTableBody', quoteId);
				} else if (flg == 'editDsgn') {
					var quoteIndex = this.getQuoteIdx(quoteDesignId);
					if (quoteIndex != -1) {
						lstQuotes.splice(quoteIndex, 1, quoDsn);
						this.setQuotesTable();
						this.highlightRowQuoteDesignId('quoteTableBody', quoteDesignId);
					}
				} else {
					this.getQuoteDesign(quoteId, designId);
					lstQuotes.push(quoDsn);
					this.setQuotesTable();
					this.highlightRowQuoteDesignId('quoteTableBody', quoteDesignId);
				}
			} else {
				toast.error(response.data.SvcMsg);
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((e) => {
			console.log('Service failed: ' + e)
			//toast.error('Service failed: '+e);
		});
		this.closePoPup();
	}

	getQuoteIdx = (quoteDesignId) => {
		for (var i = 0; i < lstQuotes.length; i++) {
			if (quoteDesignId == lstQuotes[i].quoteDesignId) {
				return i;
			}
		}
		return -1;
	}

	closePoPup = () => {
		$('.designPopup,.ipoPopup').hide();
		$('.main, .cd-panel').removeClass('addOpacity');
	}


	getQuoteDesign = (quoteId, designId) => {
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.get(httpURL + '/a/quo/listQuoDsn', {
			params: { 'quoteId': quoteId }, withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === "Success") {
				this.setState({
					designQuoteList: response.data.lstQuoteDesign,
				})
				lstQuoteDesigns = this.state.designQuoteList;
				this.setQuoteDesignTable();

				$('#quoteDesignTableBody tr').each(function () {
					if ($(this).find('td:eq(0)').text() == designId) {
						$(this).trigger('click');
					}
				});
				this.getQuoteWeaver(quoteId);
			}
			else {
				toast.error(response.data.SvcMsg);
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((e) => {
			toast.error('Service failed: ' + e);
		});
	}

	setQuoteDesignTable = () => {
		$('#quoteDesignTableBody tr').remove();
		var table = document.getElementById('quoteDesignTable');
		var tbody = document.getElementById('quoteDesignTableBody');

		for (var i = 0; i < lstQuoteDesigns.length; i++) {
			var DesignId = lstQuoteDesigns[i].designId;
			var quoteDesignId = lstQuoteDesigns[i].quoteDesignId;
			var designNoColor = lstQuoteDesigns[i].designNoColor;
			var csLength = lstQuoteDesigns[i].csLength == 0 ? '' : lstQuoteDesigns[i].csLength;
			var csWidth = lstQuoteDesigns[i].csWidth == 0 ? '' : lstQuoteDesigns[i].csWidth;
			var expectedDt = lstQuoteDesigns[i].expectedDt;
			var construction = lstQuoteDesigns[i].construction;
			var yarnCount = lstQuoteDesigns[i].yarnCount;
			var season = lstQuoteDesigns[i].season;
			var bpoNo = lstQuoteDesigns[i].bpoNo;
			var bpoId = lstQuoteDesigns[i].bpoId;
			var bpoStyleId = lstQuoteDesigns[i].bpoStyleId;
			var deliveryDt = lstQuoteDesigns[i].deliveryDt;
			var style = lstQuoteDesigns[i].style;
			var color = lstQuoteDesigns[i].color;
			var length = lstQuoteDesigns[i].length == 0 ? '' : lstQuoteDesigns[i].length;

			var row = document.createElement('tr');
			row.onclick = (e) => {
				$($(e.target).closest('tr')).addClass('selected').siblings().removeClass('selected');
				this.setMachineQuote($('#designColorTableBody tr.selected').find('td:eq(0)').text());
				var qDesignId = $('#quoteDesignTableBody tr.selected').find('td:eq(1)').text();
				var notes = this.getdesignDesData(qDesignId);
				if (notes != -1) {
					$('#notes').val(notes.notes);
				}
			}

			var pipe = csLength + " | " + csWidth + " | " + construction;

			this.addTD(row, DesignId, 'text-right');
			this.addTD(row, quoteDesignId, 'no-display');
			this.addTD(row, designNoColor, '');
			this.addTD(row, expectedDt, 'text-center');
			this.addTD(row, pipe, 'text-center');
			this.addTD(row, yarnCount, '');
			this.addTD(row, season, '');
			this.addTD(row, bpoNo, '');
			this.addTD(row, bpoId, 'no-display');
			this.addTD(row, bpoStyleId, 'no-display');
			this.addTD(row, deliveryDt, 'text-center');
			this.addTD(row, style, '');
			this.addTD(row, color, '');
			this.addTD(row, length, 'text-right');
			this.addTDEdit1(row, 'glyphicon glyphicon-trash', 'text-center');
			this.addTDCbx(row, 'text-center');

			tbody.append(row);
		}
		table.append(tbody);
	}

	getQuoteWeaver = (quoteId) => {
		var designId = $('#designColorTableBody tr.selected').find('td:eq(0)').text();
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.get(httpURL + '/a/quo/listQuoWvr', {
			params: { 'quoteId': quoteId }, withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === "Success") {
				this.setState({
					weaverQuoteList: response.data.lstQuoteWeavers,
				})
				lstQuoteWeaver = this.state.weaverQuoteList;
				this.setQuoteWeaverTable();
				$('#quoteWeaverTableBody tr').find('input:checkbox').attr('disabled', true);
			}
			else {
				toast.error(response.data.SvcMsg);
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((e) => {
			toast.error('Service failed: ' + e);
		});
	}

	setQuoteWeaverTable = (lstDesignId) => {
		$('#quoteWeaverTableBody tr').remove();
		var table = document.getElementById('quoteWeaverTable');
		var tbody = document.getElementById('quoteWeaverTableBody');
		var filterDesignNo = $('#filterDesignNo').val().trim().toLowerCase();

		for (var i = 0; i < lstQuoteWeaver.length; i++) {
			var quoteId = lstQuoteWeaver[i].quoteId;
			var designId = lstQuoteWeaver[i].designId;
			var quoteDesignId = lstQuoteWeaver[i].quoteDesignId;
			var designNoColor = lstQuoteWeaver[i].designNoColor;
			var weaver = lstQuoteWeaver[i].lstWeavers;

			for (var j = 0; j < weaver.length; j++) {

				var row = document.createElement('tr');
				/*row.onclick =(e)=>{
					$($(e.target).closest('tr').find('td:not(:eq(0))')).addClass('selected');
					$($(e.target).closest('tr')).siblings().find('td').removeClass('selected');
					var x = $(e.target).closest('tr').attr('class').split(' ')[0];
					console.log('data-designid='+x);
					$('td[data-designid='+x+']').css('backgroundColor', 'red');
					//this.setWeaverFunction();
			}*/

				row.className = designId;
				row.dataset.designcolor = designNoColor;
				if (j == 0) {
					this.addTDSpan(row, designNoColor, '', weaver.length, quoteId, designId);
				}
				if (designNoColor.toLowerCase().indexOf(filterDesignNo) === -1)
					continue;

				this.addTD(row, quoteId, 'no-display');
				this.addTD(row, quoteDesignId, 'no-display');
				this.addTD(row, designId, 'no-display');
				this.addTD(row, weaver[j].weaver, '');
				this.addTD(row, weaver[j].city, '');
				this.addTD(row, weaver[j].requestedOn, 'text-center');
				this.addTD(row, weaver[j].respondOn, 'text-center');
				this.addTD(row, weaver[j].rate == 0 ? '' : weaver[j].rate, 'text-right');
				this.addTD(row, weaver[j].minQuantity == 0 ? '' : weaver[j].minQuantity, 'text-right');
				this.addTD(row, weaver[j].minRate == 0 ? '' : weaver[j].minRate, 'text-right');
				this.addTD(row, weaver[j].construction, '');
				this.addTD(row, weaver[j].yarnCount, '');
				this.addTD(row, weaver[j].quality, '');
				this.addTD(row, weaver[j].ipoId, 'no-display');
				this.addTD(row, weaver[j].ipoNo, '');
				this.addTD(row, weaver[j].acceptedOn, 'text-center');
				this.addTDCbx1(row, weaver[j].flagAccept, 'text-center');
				this.addTD(row, quoteDesignId, 'no-display');
				this.addTD(row, weaver[j].weaverId, 'no-display');
				tbody.append(row);

				if (lstDesignId != undefined) {
					if (lstDesignId.length != 0) {
						if ($.inArray(designId, lstDesignId) != -1) {
							$(row).css('backgroundColor', '#dadffc');
							$(row).find('input:checkbox').attr('disabled', false);
						} else {
							$(row).css('backgroundColor', 'none');
							$(row).find('input:checkbox').attr('disabled', true);
						}
					} else {
						$('#quoteWeaverTableBody tr').find('input:checkbox').attr('disabled', true);
					}
				}
			}
		}
		table.append(tbody);
	}

	addTD(row, val, classname) {
		var cell = document.createElement('td');
		var text = document.createTextNode(val);
		cell.className = classname;
		cell.append(text);
		row.append(cell);
	}

	addTDSpan(row, val, classname, span, quoteId, designId) {
		var cell = document.createElement('td');
		cell.rowSpan = span;
		cell.dataset.designid = designId;
		cell.dataset.quoteid = quoteId;
		var text = document.createTextNode(val);
		cell.className = classname;
		cell.append(text);
		row.append(cell);
	}

	addTDEdit(row, val, classname) {
		var cell = document.createElement('td');
		var span = document.createElement('span');
		cell.className = classname;
		span.className = val;
		span.style.position = 'relative';
		span.style.cursor = 'pointer';

		span.onclick = (e) => {
			$(e.target.closest('tr')).addClass('selected').siblings().removeClass('selected');

			/*e.stopPropagation();
			$('.cd-panel').addClass('is-visible');
			if($(e.target).closest('tr').find(poStyleIdCol).text() == ''){
				$('#editStyle').show().siblings('#addPo,#editPo,#viewProgress').hide();
				this.setState({flgStyle:true});
			}else{
				$('#editStyle').show().siblings('#addPo,#editPo,#viewProgress').hide();
				this.setState({flgStyle:false});
			}
			$('#addStyle,#editStyle').show().siblings('#addPo,#editPo,#viewProgress').hide();
			$('#maintainStyleForm').show().siblings().hide();
			//this.getPoShowBuyer();
			var date1 = new Date();
			this.setState({
				flg : true,
				minDate:date1,
				startDate : null,
			});*/
		};
		cell.append(span);
		row.append(cell);
	}

	addTDCbx(row, classname) {
		var cell = document.createElement('td');
		cell.className = classname;
		var cbx = document.createElement('input');
		cbx.type = 'checkbox';
		cbx.name = 'object';
		cbx.onclick = (e) => {
			e.stopPropagation();
			this.getDesignId();
		};
		cell.append(cbx);
		row.append(cell);
	}
	addTDCbx1(row, val, classname) {
		var cell = document.createElement('td');
		cell.className = classname;
		var cbx = document.createElement('input');
		cbx.type = 'checkbox';
		cbx.name = 'object';
		cbx.onclick = (e) => {
			e.stopPropagation();
		};
		cell.append(cbx);
		row.append(cell);
	}

	getDesignId = () => {
		var lstDesignId = [];
		$('#quoteDesignTableBody tr').each(function () {
			if ($(this).find('input[type="checkbox"]').prop('checked')) {
				var designId = $(this).find('td:eq(0)').text();
				lstDesignId.push(parseInt(designId));
			}
		});
		this.setQuoteWeaverTable(lstDesignId);
	}

	requestQuotes = () => {
		$('#request').prop("disabled", true);
		var quoWvr = {};
		var quoteId = $('#inp_quoteId').val();
		var weaver = [];
		var count = 0;
		var dId = 0;
		wvrDesign = [];

		$('#quoteDesignTableBody tr').each(function () {
			if ($(this).find('input[type="checkbox"]').prop('checked')) {
				dId = $(this).find('td:eq(0)').text();
				return false;
			}
		});

		$('#quoteWeaverTableBody tr').each((i, e) => {
			if ($(e).find('input[type="checkbox"]').prop('checked') == true) {
				count++;
				var designId = $(e).attr('class');
				var weaverId = $(e).find('td:last-child()').text();
				var quoteDesignId = $(e).find('td:nth-last-child(2)').text();
				var getWvrData = this.getWvrData(designId, weaverId);
				var x = this.checkExist(designId);

				if (dId != designId) {
					dId = designId;
					weaver = [];
				}
				weaver.push({ 'weaverId': getWvrData.weaverId, 'requestedOn': getWvrData.requestedOn == "" ? null : getWvrData.requestedOn, 'respondOn': getWvrData.respondOn == "" ? null : getWvrData.respondOn, 'ipoId': getWvrData.ipoId == "" ? null : getWvrData.ipoId, 'acceptedOn': getWvrData.acceptedOn == "" ? null : getWvrData.acceptedOn });

				if (x == -1) {
					wvrDesign.push({ 'designId': designId, 'quoteDesignId': quoteDesignId, 'weavers': weaver });
				} else {
					wvrDesign[x].weavers = weaver;
				}

				quoWvr.quoteId = quoteId;
				quoWvr.wvrDesign = wvrDesign;
			}
		});

		if (count == 0) {
			toast.warning('Please select any weaver');
			$("#request").removeAttr('disabled');
			return false;
		}
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.post(httpURL + '/a/quo/saveQuoWvr',
			queryString.stringify({ 'quoWvr': JSON.stringify(quoWvr) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === "Success") {
				toast.success(response.data.SvcMsg);
				this.getQuoteWeaver(quoteId);
				$('#quoteDesignTableBody tr').find('input:checkbox').prop('checked', false);
			} else {
				toast.error(response.data.SvcMsg);
			}
			setTimeout(function () { $('#request').removeAttr("disabled"); }, 500);
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((e) => {
			toast.error('Service failed: ' + e);
		});
	}

	checkExist(designId) {
		for (var i = 0; i < wvrDesign.length; i++) {
			var id = wvrDesign[i].designId;
			if (designId == id) {
				return i;
			}
		}
		return -1;
	}

	getWvrData = (designId, weaverId) => {
		for (var i = 0; i < lstQuoteWeaver.length; i++) {
			if (lstQuoteWeaver[i].designId == designId) {
				var lstWeavers = lstQuoteWeaver[i].lstWeavers;
				for (var j = 0; j < lstWeavers.length; j++) {
					if (lstWeavers[j].weaverId == weaverId) {
						return lstWeavers[j];
					}
				}
				return -1;
			}
		}
	}

	acceptQuotes = () => {
		$('#accept').prop("disabled", true);
		var quoWvr = {};
		var quoteId = $('#inp_quoteId').val();
		var weaver = [];
		var count = 0;
		var dId = 0;
		wvrDesign = [];

		$('#quoteDesignTableBody tr').each(function () {
			if ($(this).find('input[type="checkbox"]').prop('checked')) {
				dId = $(this).find('td:eq(0)').text();
				return false;
			}
		});

		$('#quoteWeaverTableBody tr').each((i, e) => {
			if ($(e).find('input[type="checkbox"]').prop('checked') == true) {
				count++;
				var designId = $(e).attr('class');
				var quoteDesignId;
				if ($(e).find('td').length == 20) {
					quoteDesignId = $(e).find('td:eq(2)').text();
				} else {
					quoteDesignId = $(e).find('td:eq(1)').text();
				}

				var weaverId = $(e).find('td:last-child()').text();
				var getWvrData = this.getWvrData(designId, weaverId);

				var x = this.checkExist(designId);

				if (dId != designId) {
					dId = designId;
					weaver = [];
				}
				weaver.push({ 'weaverId': getWvrData.weaverId, 'requestedOn': getWvrData.requestedOn == "" ? null : getWvrData.requestedOn, 'respondOn': getWvrData.respondOn == "" ? null : getWvrData.respondOn, 'acceptedOn': getWvrData.acceptedOn == "" ? null : getWvrData.acceptedOn });

				if (x == -1) {
					wvrDesign.push({ 'designId': designId, 'quoteDesignId': quoteDesignId, 'weavers': weaver });
				} else {
					wvrDesign[x].weavers = weaver;
				}

				quoWvr.quoteId = quoteId;
				quoWvr.wvrDesign = wvrDesign;
			}
		});

		if (count == 0) {
			toast.warning('Please select any weaver');
			$("#accept").removeAttr('disabled');
			return false;
		}
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.post(httpURL + '/a/quo/acceptQuoWvr',
			queryString.stringify({ 'quoWvr': JSON.stringify(quoWvr) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === "Success") {
				toast.success(response.data.SvcMsg);
				this.getQuoteWeaver(quoteId);
				$('#quoteDesignTableBody tr').find('input:checkbox').prop('checked', false);
			} else {
				toast.error(response.data.SvcMsg);
			}
			setTimeout(function () { $('#accept').removeAttr("disabled"); }, 500);

			this.setState({ loader: 'none', opacity: 1 });
		}).catch((e) => {
			toast.error('Service failed: ' + e);
		});
	}

	createIntPo = () => {
		var quoWvr = {};
		var quoteId = $('#inp_quoteId').val();
		var design = [];
		var dId = '';
		$('#quoteDesignTableBody tr').each(function () {
			if ($(this).find('input[type="checkbox"]').prop('checked')) {
				var expectedDt = $(this).find('td:eq(3)').text();
				var bpoId = $(this).find('td:eq(8)').text();
				var bpoStyleId = $(this).find('td:eq(9)').text();

				dId = $(this).find('td:eq(0)').text();

				$('#quoteWeaverTableBody tr').each((i, e) => {
					if ($(e).find('input[type="checkbox"]').prop('checked') == true) {
						var designId = $(e).attr('class');
						var weaverId = $(e).find('td:last-child()').text();
						var quoteDesignId = $(e).find('td:nth-last-child(2)').text();

						if (dId == designId) {
							design.push({
								'designId': designId,
								'deliveryDt': expectedDt,
								'quoteDesignId': quoteDesignId,
								'bpoId': bpoId,
								'bpoStyleId': bpoStyleId
							});
						}

						quoWvr.quoteId = quoteId;
						quoWvr.ipoNo = $('#inp_ipoNo').val();
						quoWvr.ppsDt = $('#inp_ppsDt').val();
						quoWvr.weaverId = weaverId;
						quoWvr.arrQuoteDesign = design;
					}
				});
			}
		});
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.post(httpURL + '/a/ipo/create',
			queryString.stringify({ 'ipo': JSON.stringify(quoWvr) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === "Success") {
				toast.success(response.data.SvcMsg);
				this.closePoPup();
				this.getQuoteWeaver(quoteId);
				$('#quoteDesignTableBody tr').find('input:checkbox').prop('checked', false);
			} else {
				toast.error(response.data.SvcMsg);
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((e) => {
			toast.error('Service failed: ' + e);
		});
	}

	showAvailability = () => {
		var weaver = [];
		var lstWeaver = [];
		$('#quoteWeaverTableBody tr').each(function () {
			if ($(this).find('input[type="checkbox"]').prop('checked')) {
				var wvr = $(this).find('td:last-child()').text();
				weaver.push(wvr);
			}
		});

		if (weaver.length == 0) {
			toast.warning('Please select any weaver');
			return false;
		}

		$.each(weaver, function (i, el) {
			if ($.inArray(el, lstWeaver) === -1)
				lstWeaver.push(el);
		});

		this.props.history.push({
			pathname: '/cs/availability',
			search: '?lstWeaver=' + lstWeaver,
		});
	}

	editBPO = () => {
		$('#bpoDesignPopup').show().siblings().hide();
		this.handleResize();
		var bpo = {};
		var quoteId = $('#quoteTableBody tr.selected').find(COL_QTT_QUOTEID).text();
		var designNoColor = $('#designColorTableBody tr.selected').find('td:eq(1)').text();
		$('#quoteId').val(quoteId);
		$('#inp_designColor').val(designNoColor);
		var fromDt = $('#inp_fromDate').val();
		var toDt = $('#inp_toDate').val();
		var designId = $('#designColorTableBody tr.selected').find('td:eq(0)').text();
		bpo = { designId, fromDt, toDt }
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.post(httpURL + '/a/quo/lstbuyerpo',
			queryString.stringify({ 'bpo': JSON.stringify(bpo) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				lstCompanyPO = response.data.lstQuotesBuyerPO;
				this.setBuyerPOTable();
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'No BuyerPO data exist for this design') {
					lstCompanyPO = [];
					this.setBuyerPOTable();
				}
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	setBuyerPOTable = () => {
		$('#buyerPOTableBody tr').remove();
		var table = document.getElementById('buyerPOTable');
		var tbody = document.getElementById('buyerPOTableBody');
		var filterPoNo = $('#poNo').val().trim().toLowerCase();
		var filterStyle = $('#filterStyle').val().trim().toLowerCase();

		for (var i = 0; i < lstCompanyPO.length; i++) {
			var parentCompId = lstCompanyPO[i].parentCompId;
			var parentComp = lstCompanyPO[i].parentComp;
			var bpoId = lstCompanyPO[i].bpoId;
			var bpoNo = lstCompanyPO[i].bpoNo;
			var deliveryDt = lstCompanyPO[i].deliveryDt === null ? '-' : lstCompanyPO[i].deliveryDt;
			var buyerQuality = lstCompanyPO[i].buyerQuality;
			var bpoStyleId = lstCompanyPO[i].bpoStyleId;
			var style = lstCompanyPO[i].style;
			var color = lstCompanyPO[i].color;
			var qualityId = lstCompanyPO[i].qualityId;
			var quality = lstCompanyPO[i].quality;
			var length = lstCompanyPO[i].length;
			length = length == 0 ? '' : length;
			var width = lstCompanyPO[i].width;
			width = width == 0 ? '' : width;
			var season = lstCompanyPO[i].season;
			var bufferDays = lstCompanyPO[i].bufferDays;
			bufferDays = bufferDays == 0 ? '' : bufferDays;
			var construction = lstCompanyPO[i].construction;
			var yarnCount = lstCompanyPO[i].yarnCount;

			var row = document.createElement('tr');
			row.id = 'poTable' + bpoId;
			row.onclick = (e) => {
				$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
			}

			if (bpoNo.toLowerCase().indexOf(filterPoNo) === -1)
				continue;
			if (style.toLowerCase().indexOf(filterStyle) === -1)
				continue;

			this.addTD(row, parentCompId, 'no-display');
			this.addTD(row, parentComp, '');
			this.addTD(row, bpoId, 'no-display');
			this.addTD(row, bpoStyleId, 'no-display');
			this.addTD(row, bpoNo, '');
			this.addTD(row, season, '');
			this.addTD(row, deliveryDt, 'text-center');
			this.addTD(row, buyerQuality, '');
			this.addTD(row, style, '');
			this.addTD(row, color, '');
			this.addTD(row, qualityId, 'no-display');
			this.addTD(row, quality, '');
			this.addTD(row, length, 'text-right');
			this.addTD(row, width, 'no-display');
			this.addTD(row, bufferDays, 'no-display');
			this.addTD(row, construction, '');
			this.addTD(row, yarnCount, '');

			tbody.append(row);
		}
		table.append(tbody);
	}

	selectBPO = () => {
		var bpo = {};
		var quoteId = $('#quoteId').val();
		var designId = $('#designColorTableBody tr.selected').find('td:eq(0)').text();
		var parentCompId = $('#buyerPOTableBody tr.selected').find(COL_BPT_PARENTCOMPID).text();
		var parentComp = $('#buyerPOTableBody tr.selected').find(COL_BPT_PARENTCOMP).text();
		var bpoId = $('#buyerPOTableBody tr.selected').find(COL_BPT_BPOID).text();
		var bpoNo = $('#buyerPOTableBody tr.selected').find(COL_BPT_BPONO).text();
		var bpoStyleId = $('#buyerPOTableBody tr.selected').find(COL_BPT_BPOSTYLEID).text();
		var style = $('#buyerPOTableBody tr.selected').find(COL_BPT_STYLE).text();
		var color = $('#buyerPOTableBody tr.selected').find(COL_BPT_COLOR).text();
		var length = $('#buyerPOTableBody tr.selected').find(COL_BPT_LENGTH).text();
		var deliveryDt = $('#buyerPOTableBody tr.selected').find(COL_BPT_DELIVERYDT).text();
		var buyerQuality = $('#buyerPOTableBody tr.selected').find(COL_BPT_BUYERQUALITY).text();

		if (bpoId == '') {
			toast.warning('Please select buyer po first');
			return false;
		}
		bpo = { quoteId, designId, parentCompId, bpoId, bpoStyleId };
		this.setState({ loader: 'block', opacity: 0.5 });
		axiosInstance.post(httpURL + '/a/quo/savebpodtls',
			queryString.stringify({ 'bpo': JSON.stringify(bpo) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === "Success") {
				toast.success(response.data.SvcMsg);
				$('#quoteDesignPopup').show().siblings().hide();
				$('#inp_company').val(parentComp);
				$('#inp_buyerPo').val(bpoNo);
				$('#inp_style').val(style);
				$('#inp_length').val(length == 0 ? '' : length);
				$('#inp_color').val(color);
				$('#inp_deliveryDt').val(deliveryDt);
				$('#inp_quality').val(buyerQuality);
				var quoteDesignId = $('#quoteTableBody tr.selected').find(COL_QTT_QTDESIGNID).text();
				var getQtIdx = this.getQuoteIdx(quoteDesignId);
				if (getQtIdx != -1) {
					lstQuotes[getQtIdx].parentCompId = parentCompId;
					lstQuotes[getQtIdx].parentComp = parentComp;
					lstQuotes[getQtIdx].bpoId = bpoId;
					lstQuotes[getQtIdx].bpoNo = bpoNo;
					lstQuotes[getQtIdx].bpoStyleId = bpoStyleId;
					lstQuotes[getQtIdx].style = style;
					lstQuotes[getQtIdx].color = color;
					lstQuotes[getQtIdx].length = length;
					lstQuotes[getQtIdx].deliveryDt = deliveryDt;
					lstQuotes[getQtIdx].buyerQuality = buyerQuality;
					this.setQuotesTable();
					this.highlightRowQuoteDesignId('quoteTableBody', quoteDesignId);
				}
			} else {
				toast.error(response.data.SvcMsg);
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((e) => {
			toast.error('Service failed: ' + e);
		});

	}

	sortAscByDesign = () => {
		if (sortVal != 'aspo') {
			sortVal = 'aspo';
			$("#designAsDtIcon").css("color", "gray");
			$("#designDsDtIcon").css("color", "#111");
			//	$("#deliveryAsDtIcon").css("color", "#111");
			//$("#deliveryDsDtIcon").css("color", "#111");

			var val1;
			var val2;

			for (var i = 0; i < lstQuotes.length - 1; i++) {
				val1 = lstQuotes[i].designNoColor;
				for (var j = i + 1; j < lstQuotes.length; j++) {
					val2 = lstQuotes[j].designNoColor;
					if (val1 > val2) {
						var tmp = lstQuotes[j];
						lstQuotes[j] = lstQuotes[i];
						lstQuotes[i] = tmp;
						val1 = lstQuotes[i].designNoColor;
					}
				}
			}
			this.setQuotesTable();
		}
	}
	sortDesByDesign = () => {
		if (sortVal != 'dspo') {
			sortVal = 'dspo';
			$("#designAsDtIcon").css("color", "#111");
			$("#designDsDtIcon").css("color", "gray");
			//$("#deliveryAsDtIcon").css("color", "#111");
			//$("#deliveryDsDtIcon").css("color", "#111");

			var val1;
			var val2;

			for (var i = 0; i < lstQuotes.length - 1; i++) {
				val1 = lstQuotes[i].designNoColor;
				for (var j = i + 1; j < lstQuotes.length; j++) {
					val2 = lstQuotes[j].designNoColor;
					if (val1 < val2) {
						var tmp = lstQuotes[j];
						lstQuotes[j] = lstQuotes[i];
						lstQuotes[i] = tmp;
						val1 = lstQuotes[i].designNoColor;
					}
				}
			}
			this.setQuotesTable();
		}
	}

	sortAscByPo = () => {
		if (sortVal != 'aspo') {
			sortVal = 'aspo';
			$("#poAsDtIcon").css("color", "gray");
			$("#poDsDtIcon").css("color", "#111");
			$("#deliveryAsDtIcon").css("color", "#111");
			$("#deliveryDsDtIcon").css("color", "#111");

			var val1;
			var val2;

			for (var i = 0; i < lstCompanyPO.length - 1; i++) {
				val1 = lstCompanyPO[i].bpoNo;
				for (var j = i + 1; j < lstCompanyPO.length; j++) {
					val2 = lstCompanyPO[j].bpoNo;
					if (val1 > val2) {
						var tmp = lstCompanyPO[j];
						lstCompanyPO[j] = lstCompanyPO[i];
						lstCompanyPO[i] = tmp;
						val1 = lstCompanyPO[i].bpoNo;
					}
				}
			}
			this.setBuyerPOTable();
		}
	}

	sortDesByPo = () => {
		if (sortVal != 'dspo') {
			sortVal = 'dspo';
			$("#poAsDtIcon").css("color", "#111");
			$("#poDsDtIcon").css("color", "gray");
			$("#deliveryAsDtIcon").css("color", "#111");
			$("#deliveryDsDtIcon").css("color", "#111");

			var val1;
			var val2;

			for (var i = 0; i < lstCompanyPO.length - 1; i++) {
				val1 = lstCompanyPO[i].bpoNo;
				for (var j = i + 1; j < lstCompanyPO.length; j++) {
					val2 = lstCompanyPO[j].bpoNo;
					if (val1 < val2) {
						var tmp = lstCompanyPO[j];
						lstCompanyPO[j] = lstCompanyPO[i];
						lstCompanyPO[i] = tmp;
						val1 = lstCompanyPO[i].bpoNo;
					}
				}
			}
			this.setBuyerPOTable();
		}
	}

	sortAscByDelivery = () => {
		if (sortVal != 'asdel') {
			sortVal = 'asdel';
			$("#poAsDtIcon").css("color", "#111");
			$("#poDsDtIcon").css("color", "#111");
			$("#deliveryAsDtIcon").css("color", "gray");
			$("#deliveryDsDtIcon").css("color", "#111");

			var val1;
			var val2;
			var parts;
			var parts2;
			var dt1;
			var dt2;

			for (var i = 0; i < lstCompanyPO.length - 1; i++) {
				val1 = lstCompanyPO[i].deliveryDt;
				if (val1 != null) {
					parts = val1.split('-');
					dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
					for (var j = i + 1; j < lstCompanyPO.length; j++) {
						val2 = lstCompanyPO[j].deliveryDt;
						if (val2 != null) {
							parts2 = val2.split('-');
							dt2 = new Date(parts2[2], parts2[1] - 1, parts2[0]);

							if (dt1 > dt2) {
								var tmp = lstCompanyPO[j];
								lstCompanyPO[j] = lstCompanyPO[i];
								lstCompanyPO[i] = tmp;
								val1 = lstCompanyPO[i].deliveryDt;
								parts = val1.split('-');
								dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
							}
						}
					}
				}
			}
			this.setBuyerPOTable();
		}
	}

	sortDesByDelivery = () => {
		if (sortVal != 'dsdel') {
			sortVal = 'dsdel';
			$("#poAsDtIcon").css("color", "#111");
			$("#poDsDtIcon").css("color", "#111");
			$("#deliveryAsDtIcon").css("color", "#111");
			$("#deliveryDsDtIcon").css("color", "gray");

			var val1;
			var val2;
			var parts;
			var parts2;
			var dt1;
			var dt2;

			for (var i = 0; i < lstCompanyPO.length - 1; i++) {
				val1 = lstCompanyPO[i].deliveryDt;
				if (val1 != null) {
					parts = val1.split('-');
					dt1 = new Date(parts[2], parts[1] - 1, parts[0]);

					for (var j = i + 1; j < lstCompanyPO.length; j++) {
						val2 = lstCompanyPO[j].deliveryDt;
						if (val2 != null) {
							parts2 = val2.split('-');
							dt2 = new Date(parts2[2], parts2[1] - 1, parts2[0]);

							if (dt1 < dt2) {
								var tmp = lstCompanyPO[j];
								lstCompanyPO[j] = lstCompanyPO[i];
								lstCompanyPO[i] = tmp;
								val1 = lstCompanyPO[i].deliveryDt;
								parts = val1.split('-');
								dt1 = new Date(parts[2], parts[1] - 1, parts[0]);
							}
						}
					}
				}
			}
			this.setBuyerPOTable();
		}
	}

	render() {
		httpURL = window.httpURL;
		return (
			<div style={{ height: '100%' }}>
				<Header />
				<ToastContainer autoClose={2000} hideProgressBar />
				<div style={{ position: 'fixed', width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: this.state.loader, zIndex: 9999 }}>
					<img src={require("../images/loader.gif")} alt="Loader..." />
				</div>
				<div className="main" style={{ opacity: this.state.opacity }}>
					<div className="container-fluid">
						<div className="col-sm-12 col-centered">
							<div style={{ marginBottom: 10 }}>
								<button style={{ marginLeft: 0 }} type="button" className="btn btn-warning" onClick={this.requestNewQuotes} id="requestNewQuotes">Create New Quotes</button>
							</div>
							<div className="col-sm-12 padding-remove">
								<table className="tableLayout1" style={{ width: this.state.width }}>
									<thead>
										<tr>
											<th style={{ width: 30 }}>Quote Id</th>
											<th style={{ width: 30 }}>Created On</th>
											<th style={{ width: 30 }}>Requested On</th>
											<th style={{ width: 30 }}>Style</th>
											<th style={{ width: 50, display: 'none' }}>Quote Design Id</th>
											<th style={{ width: 50 }}>
												<div style={{ float: 'left', width: '80%' }}>
													<input type="text" onChange={this.setQuotesTable} className="form-control inp-search" id="filterDesignColor" placeholder="Design Color" />
												</div>
												<div style={{ width: 10, float: 'left', marginLeft: 2, marginTop: 4 }}>
													<div className="assending">
														<span id="designAsDtIcon" onClick={this.sortAscByDesign} className="glyphicon glyphicon-triangle-top"></span>
													</div>
													<div className="desending">
														<span id="designDsDtIcon" onClick={this.sortDesByDesign} className="glyphicon glyphicon-triangle-bottom"></span>
													</div>
												</div>
											</th>
											<th style={{ width: 50, display: 'none' }}>Company Id</th>
											<th style={{ width: 60 }}>Parent Company</th>
											<th style={{ width: 50, display: 'none' }}>Buyer PO Id</th>
											<th style={{ width: 50 }}>Buyer PO</th>
											<th style={{ width: 50, display: 'none' }}>Style Id</th>
											<th style={{ width: 40 }}>Style</th>
											<th style={{ width: 40 }}>Color</th>
											<th style={{ width: 50, display: 'none' }}>Delivery Dt</th>
											<th style={{ width: 50 }}>
												<div style={{ float: 'left', width: '100%' }}>
													<select type="text" onChange={this.setQuotesTable} className="form-control inp-search" id="filterStatusCmb"> </select>
												</div>
											</th>
											<th style={{ width: 30 }}>Action</th>
											<th style={{ width: 50, display: 'none' }}>Buyer Quality</th>
										</tr>
									</thead>
								</table>
								<div className="col-sm-12 quoteTableDiv padding-remove">
									<table id="quoteTable" className="tableLayout">
										<colgroup>
											<col width="30" />
											<col width="30" />
											<col width="30" />
											<col width="30" />
											<col width="50" />
											<col width="60" />
											<col width="50" />
											<col width="40" />
											<col width="40" />
											<col width="50" />
											<col width="30" />
										</colgroup>
										<tbody id="quoteTableBody"></tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="designPopup1">
					<header style={{ width: '95%' }}>
						<h3 id="maintainQuote">Maintain Quote</h3>
						<a href="#0" className="cd-panel-close glyphicon glyphicon-remove" onClick={this.hideSlider}>Close</a>
					</header>

					<div style={{ width: '95%' }}>
						<div className="cd-panel-content" style={{ padding: '35px 0% 5px' }}>
							<div className="col-sm-12 padding-remove">
								<label style={{ marginLeft: 15 }} htmlFor="inp_quoteId">Quote Id:</label>
								<input readOnly style={{ marginLeft: 15, width: 100, height: 35, border: '1px solid #ccc', borderRadius: 6, padding: 5 }} type="text" className="inp-search text-right" id="inp_quoteId" placeholder="Quote ID" />
								<button style={{ marginLeft: 15 }} onClick={this.openDesignPopup.bind(this)} type="button" className="btn btn-warning">Add Design</button>
							</div>
							<div className="col-sm-12">
								<div className="row" style={{ marginTop: 10 }}>
									<div className="col-sm-9">
										<table className="tableLayout2" style={{ width: this.state.width1 }}>
											<thead>
												<tr>
													<th style={{ width: 40, textAlign: 'center' }}>Design Id</th>
													<th style={{ width: 60 }}>Design Color</th>
													<th style={{ width: 60 }}>Expected Date</th>
													<th style={{ width: 100 }}>Length | Width | Construction</th>
													<th style={{ width: 80 }}>Yarn Count</th>
													<th style={{ width: 50 }}>Season</th>
													<th style={{ width: 60 }}>Buyer PO</th>
													<th style={{ width: 60 }}>Delivery Date</th>
													<th style={{ width: 40 }}>Style</th>
													<th style={{ width: 40 }}>Color</th>
													<th style={{ width: 40 }}>Length</th>
													<th style={{ width: 20 }}>...</th>
													<th style={{ width: 40 }}>Select</th>
												</tr>
											</thead>
										</table>
										<div className="col-sm-12 quoteDesignTableDiv padding-remove">
											<table id="quoteDesignTable" className="tableLayout">
												<colgroup>
													<col width="40" />
													<col width="60" />
													<col width="60" />
													<col width="100" />
													<col width="80" />
													<col width="50" />
													<col width="60" />
													<col width="60" />
													<col width="40" />
													<col width="40" />
													<col width="40" />
													<col width="20" />
													<col width="40" />
												</colgroup>
												<tbody id="quoteDesignTableBody"></tbody>
											</table>
										</div>
									</div>
									<div className="col-sm-3" style={{ paddingLeft: 0 }}>
										<div className="col-sm-12 padding-remove" style={{ height: 135, overflowY: 'scroll' }}>
											<table id="machineTable" style={{ width: '100%' }}>
												<thead>
													<tr>
														<th style={{ width: 100, height: 35, display: 'none' }}>Machine Id</th>
														<th style={{ width: 100, height: 35 }}>Machine Type</th>
														<th style={{ width: 100, height: 35 }}>Capacity</th>
														<th style={{ width: 50, height: 35 }}>Select</th>
													</tr>
												</thead>
												<tbody id="machineTableBody">
												</tbody>
											</table>
										</div>
										<div style={{ marginTop: 5 }} className="col-sm-12 padding-remove">
											<label className="col-sm-2 padding-remove">Notes:</label>
											<div className="col-sm-10 padding-remove">
												<textarea disabled style={{ resize: "none" }} placeholder="Notes" className="form-control rounded-0" id="notes" cols="20"></textarea>
											</div>
										</div>
									</div>
								</div>
								<div className="col-sm-12 padding-remove" style={{ marginTop: 20 }}>
									<table className="tableLayout3" style={{ width: this.state.width2 }}>
										<thead>
											<tr>
												<th style={{ width: 50, display: 'none' }}>Quote Id</th>
												<th style={{ width: 50, display: 'none' }}>Quote Design Id</th>
												<th style={{ width: 50, display: 'none' }}>Design Id</th>
												<th style={{ width: 54 }}>
													<input type="text" className="form-control inp-search" onChange={this.setQuoteWeaverTable} id="filterDesignNo" placeholder="Design Color" />
												</th>
												<th style={{ width: 70 }}>Weaver</th>
												<th style={{ width: 50 }}>City</th>
												<th style={{ width: 50 }}>Requested On</th>
												<th style={{ width: 50 }}>Response On</th>
												<th style={{ width: 40 }}>Rate</th>
												<th style={{ width: 60 }}>Min Order Quantity</th>
												<th style={{ width: 60 }}>Min Order Rate</th>
												<th style={{ width: 50 }}>Construction</th>
												<th style={{ width: 40 }}>Yarn Count</th>
												<th style={{ width: 40 }}>Quality</th>
												<th style={{ width: 40, display: 'none' }}>IPO ID</th>
												<th style={{ width: 40 }}>IPO NO</th>
												<th style={{ width: 40 }}>Accept On</th>
												<th style={{ width: 50, display: 'none' }}>Quote Design Id</th>
												<th style={{ width: 50, display: 'none' }}>Weaver Id</th>
												<th style={{ width: 30 }}>Select</th>
											</tr>
										</thead>
									</table>
									<div className="col-sm-12 quoteWeaverTableDiv padding-remove">
										<table id="quoteWeaverTable" className="tableLayout">
											<colgroup>
												<col width="54" />
												<col width="70" />
												<col width="50" />
												<col width="50" />
												<col width="50" />
												<col width="40" />
												<col width="60" />
												<col width="60" />
												<col width="50" />
												<col width="40" />
												<col width="40" />
												<col width="40" />
												<col width="40" />
												<col width="30" />
											</colgroup>
											<tbody id="quoteWeaverTableBody"></tbody>
										</table>
									</div>
									<div className="pull-right" style={{ marginTop: 10 }}>
										<button style={{ marginRight: 20 }} type="button" className="btn btn-warning" onClick={this.requestQuotes} id="request">Request Quotes</button>
										<button style={{ marginRight: 20 }} type="button" className="btn btn-warning" onClick={this.acceptQuotes} id="accept">Accept Response</button>
										<button style={{ marginRight: 20 }} type="button" className="btn btn-warning" onClick={this.showAvailability} id="availability">Show Availability</button>
										<button style={{ marginRight: 20 }} type="button" className="btn btn-warning" onClick={this.openIpoPopup} id="createIntPo">Create Internal PO</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="ipoPopup">
					<div className="closeBtn" onClick={this.closePoPup.bind(this)}>
						<span style={{ position: 'absolute', color: '#fff', top: '18px', left: '18px' }} className="glyphicon glyphicon-remove"></span>
					</div>
					<form id="ipoForm" className="form-horizontal">
						<div className="form-group col-sm-12" style={{ marginTop: 20 }}>
							<label htmlFor="inp_ipoNo" className="control-label col-sm-6">Ipo No:</label>
							<div className="col-sm-6 padding-remove">
								<input type="text" className="form-control" placeholder="Ipo No" id="inp_ipoNo" />
							</div>
						</div>
						<div className="form-group col-sm-12" style={{ marginTop: 20 }}>
							<label htmlFor="inp_ppsDt" className="control-label col-sm-6">PPS Date:</label>
							<div className="col-sm-6 padding-remove">
								<DatePicker id="inp_ppsDt"
									className='form-control text-center'
									placeholderText="PPS Date"
									selected={this.state.ppsDt}
									onChange={this.handleChangePpsDt}
									dateFormat="dd-MM-yyyy"
									autoComplete='off'
								/>
							</div>
						</div>
					</form>
					<div className="text-center" style={{ marginTop: 70 }}>
						<button type="button" onClick={this.createIntPo} className="btn btn-warning">Create</button>
					</div>
				</div>
				<div className="designPopup">
					<div className="closeBtn" onClick={this.closePoPup.bind(this)}>
						<span style={{ position: 'absolute', color: '#fff', top: '18px', left: '18px' }} className="glyphicon glyphicon-remove">
						</span>
					</div>
					<div className="container-fluid">
						<div id="quoteDesignPopup" className="col-sm-11 col-centered">
							<div className="col-sm-5 col-xs-12 padding-remove">
								<table className="tableLayout4" style={{ width: this.state.width3 }}>
									<thead>
										<tr>
											<th style={{ width: 70 }}>Design Id</th>
											<th style={{ width: 100 }}>
												<input onChange={this.setDesignColorTable} type="text" className="form-control inp-search" id="designNoColor" placeholder="Design Color" />
											</th>
											<th style={{ width: 50 }}>Image</th>
											<th style={{ width: 100 }}>Updated On</th>
										</tr>
									</thead>
								</table>
								<div className="designColorTableDiv col-sm-12 col-xs-11 padding-remove">
									<table id="designColorTable" className="tableLayout">
										<colgroup>
											<col width="70" />
											<col width="100" />
											<col width="50" />
											<col width="100" />
										</colgroup>
										<tbody id="designColorTableBody">
										</tbody>
									</table>
								</div>
							</div>
							<div className="col-sm-7 col-xs-12">
								<div className="row col-sm-12" style={{ paddingRight: 0 }}>
									<div className="col-sm-7 padding-remove" style={{ height: 180, overflowY: 'scroll' }}>
										<table id="machineTable1" style={{ width: '100%' }}>
											<thead>
												<tr>
													<th style={{ width: 100, height: 39, display: 'none' }}>Machine Id</th>
													<th style={{ width: 100, height: 39 }}>Machine Type</th>
													<th style={{ width: 100, height: 39 }}>Capacity</th>
													<th style={{ width: 50, height: 39 }}>Select</th>
												</tr>
											</thead>
											<tbody id="machineTableBody1">
											</tbody>
										</table>
									</div>
									<div className="col-sm-5 pull-right padding-remove" id="designColorImageDiv2">
										<ReactImageMagnify {...{
											smallImage: {
												alt: 'Design Image',
												src: this.state.src,
												isFluidWidth: true,
											},
											largeImage: {
												src: this.state.src,
												width: 600,
												height: 900
											},
											enlargedImageContainerDimensions: {
												width: 300,
												height: 300,
											},
											enlargedImageContainerStyle: {
												left: -10,
												top: 190,
											},
										}} />
									</div>
								</div>
								<div className="col-sm-12" style={{ marginTop: 10 }}>
									<form id="quoteDesignForm" className="form-horizontal">
										<div className="row">
											<div className="form-group col-sm-6">
												<label htmlFor="inp_construction" className="control-label col-sm-6">Construction:</label>
												<div className="col-sm-6 padding-remove">
													<select className="form-control" id="inp_construction"></select>
												</div>
											</div>
											<div className="form-group col-sm-6">
												<label htmlFor="inp_company" className="control-label col-sm-6">Company:</label>
												<div className="col-sm-6 padding-remove">
													<input type="text" readOnly className="form-control" placeholder="Company" id="inp_company" />
												</div>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-sm-6">
												<label htmlFor="inp_yarnCount" className="control-label col-sm-6">Yarn Count:</label>
												<div className="col-sm-6 padding-remove">
													<select className="form-control" id="inp_yarnCount"></select>
												</div>
											</div>
											<div className="form-group col-sm-6">
												<label htmlFor="inp_buyerPo" className="control-label col-sm-6">Buyer PO:</label>
												<div className="col-sm-6 padding-remove">
													<input type="text" readOnly className="form-control" placeholder="Buyer PO" id="inp_buyerPo" />
												</div>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-sm-6">
												<label htmlFor="inp_csLength" className="control-label col-sm-6">Length:</label>
												<div className="col-sm-6 padding-remove">
													<input type="text" className="form-control" placeholder="Length" id="inp_csLength" />
												</div>
											</div>
											<div className="form-group col-sm-6">
												<label htmlFor="inp_style" className="control-label col-sm-6">Style:</label>
												<div className="col-sm-6 padding-remove">
													<input type="text" readOnly className="form-control" placeholder="Style" id="inp_style" />
												</div>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-sm-6">
												<label htmlFor="inp_csWidth" className="control-label col-sm-6">Width:</label>
												<div className="col-sm-6 padding-remove">
													<select className="form-control" id="inp_csWidth"></select>
												</div>
											</div>
											<div className="form-group col-sm-6">
												<label htmlFor="inp_color" className="control-label col-sm-6">Color:</label>
												<div className="col-sm-6 padding-remove">
													<input type="text" readOnly className="form-control" placeholder="Color" id="inp_color" />
												</div>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-sm-6">
												<label htmlFor="inp_expectedDt" className="control-label col-sm-6">Expected Dt:</label>
												<div className="col-sm-6 padding-remove">
													<DatePicker id="inp_expectedDt"
														className='form-control'
														placeholderText="Expected Date"
														selected={this.state.expectedDate}
														minDate={this.state.minDate}
														onChange={this.handleChange}
														dateFormat="dd-MM-yyyy"
														autoComplete='off'
													/>
												</div>
											</div>
											<div className="form-group col-sm-6">
												<label htmlFor="inp_deliveryDt" className="control-label col-sm-6">Delivery Dt:</label>
												<div className="col-sm-6 padding-remove">
													<input type="text" readOnly className="form-control" placeholder="Delivery Date" id="inp_deliveryDt" />
												</div>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-sm-6">
												<label htmlFor="inp_csQuality" className="control-label col-sm-6">Quality:</label>
												<div className="col-sm-6 padding-remove">
													<select className="form-control" id="inp_csQuality"></select>
												</div>
											</div>
											<div className="form-group col-sm-6">
												<label htmlFor="inp_quality" className="control-label col-sm-6">Quality:</label>
												<div className="col-sm-6 padding-remove">
													<input type="text" readOnly className="form-control" placeholder="Quality" id="inp_quality" />
												</div>
											</div>
										</div>
										<div className='row'>
											<div className="form-group col-sm-6">
												<label htmlFor="inp_notes" className="col-sm-6 text-left">Notes:</label>
											</div>
											<div className="form-group col-sm-6">
												<label htmlFor="inp_length" className="control-label col-sm-6">Length:</label>
												<div className="col-sm-6 padding-remove">
													<input type="text" readOnly className="form-control" placeholder="Length" id="inp_length" />
												</div>
											</div>
										</div>
										<div className='row'>
											<div className="form-group col-sm-7" style={{ paddingLeft: 30 }}>
												<textarea style={{ resize: "none" }} placeholder="Notes" className="form-control rounded-0" id="inp_notes" rows="2"></textarea>
											</div>
											<div className="form-group col-sm-5 text-right" style={{ paddingTop: 20 }}>
												<button type="button" onClick={this.selectDesignColor} className="btn btn-warning">Save</button>
												<button type="button" id="addEditBpo" style={{ marginLeft: 5 }} onClick={this.editBPO} className="btn btn-warning">Add/Edit BPO</button>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>


						<div id="bpoDesignPopup" className="col-sm-12 col-centered">
							<div className="col-sm-12 col-centered">
								<div style={{ marginBottom: 10 }}>
									<label htmlFor="quoteId">Quote Id</label>
									<input readOnly style={{ marginLeft: 15, width: 100, height: 35, border: '1px solid #ccc', borderRadius: 6, padding: 5 }} type="text" className="inp-search text-right" id="quoteId" placeholder="Quote ID" />
									<label style={{ marginLeft: 15 }} htmlFor="inp_designColor">Design Color:</label>
									<input readOnly style={{ marginLeft: 15, width: 100, height: 35, border: '1px solid #ccc', borderRadius: 6, padding: 5 }} type="text" className="inp-search" id="inp_designColor" placeholder="Design Color" />
									<label style={{ marginLeft: 10 }} htmlFor="inp_fromDate">From Date</label>
									<div style={{ display: 'inline-block', marginLeft: 5, width: 100 }}>
										<DatePicker id="inp_fromDate"
											className='form-control text-center'
											placeholderText="From Date"
											selected={this.state.startDate}
											onChange={this.handleChange1}
											dateFormat="dd-MM-yyyy"
											autoComplete='off'
										/>
									</div>
									<label style={{ marginLeft: 10 }} htmlFor="inp_toDate">To Date</label>
									<div style={{ display: 'inline-block', marginLeft: 5, width: 100 }}>
										<DatePicker id="inp_toDate"
											className='form-control text-center'
											placeholderText="To Date"
											selected={this.state.endDate}
											onChange={this.handleChange2}
											dateFormat="dd-MM-yyyy"
											autoComplete='off'
										/>
									</div>
									<button style={{ marginLeft: 20 }} type="button" className="btn btn-warning" onClick={this.editBPO} id="getAllPO">Get Data</button>
								</div>
								<div className="col-sm-12 padding-remove">
									<table className="tableLayout5" style={{ width: this.state.width4 }}>
										<thead>
											<tr>
												<th style={{ width: 50, display: 'none' }}>Company Id</th>
												<th style={{ width: 80 }}>Company</th>
												<th style={{ width: 50, display: 'none' }}>PO Id</th>
												<th style={{ width: 50, display: 'none' }}>Style Id</th>
												<th style={{ width: 80 }}>
													<div style={{ float: 'left', width: '80%' }}>
														<input type="text" onChange={this.setBuyerPOTable} className="form-control inp-search" id="poNo" placeholder="PO No." />
													</div>
													<div style={{ width: 10, float: 'left', marginLeft: 2, marginTop: 4 }}>
														<div className="assending">
															<span id="poAsDtIcon" onClick={this.sortAscByPo} className="glyphicon glyphicon-triangle-top"></span>
														</div>
														<div className="desending">
															<span id="poDsDtIcon" onClick={this.sortDesByPo} className="glyphicon glyphicon-triangle-bottom"></span>
														</div>
													</div>
												</th>
												<th style={{ width: 40 }}>Season</th>
												<th style={{ width: 70, textAlign: 'left' }}>
													<div style={{ width: '90%', marginLeft: '5%' }}>
														<div className="dateLabel">Delivery Date</div>
														<div className="sortIcon">
															<div className="assending">
																<span id="deliveryAsDtIcon" onClick={this.sortAscByDelivery} className="glyphicon glyphicon-triangle-top"></span>
															</div>
															<div className="desending">
																<span id="deliveryDsDtIcon" onClick={this.sortDesByDelivery} className="glyphicon glyphicon-triangle-bottom"></span>
															</div>
														</div>
													</div>
												</th>
												<th style={{ width: 50 }}>Buyer Quality</th>
												<th style={{ width: 50 }}>
													<input type="text" onChange={this.setBuyerPOTable} className="form-control inp-search" id="filterStyle" placeholder="Style" />
												</th>
												<th style={{ width: 40 }}>Color</th>
												<th style={{ width: 50, display: 'none' }}>Quality Id</th>
												<th style={{ width: 40 }}>Quality</th>
												<th style={{ width: 30 }}>Length</th>
												<th style={{ width: 30, display: 'none' }}>Width</th>
												<th style={{ width: 40, display: 'none' }}>Buffer Days</th>
												<th style={{ width: 50 }}>Construction</th>
												<th style={{ width: 40 }}>Yarn Count</th>
											</tr>
										</thead>
									</table>
									<div className="col-sm-12 buyerPOTableDiv padding-remove" style={{ height: 350 }}>
										<table id="buyerPOTable" className="tableLayout">
											<colgroup>
												<col width="80" />
												<col width="80" />
												<col width="40" />
												<col width="70" />
												<col width="50" />
												<col width="50" />
												<col width="40" />
												<col width="40" />
												<col width="30" />
												<col width="50" />
												<col width="40" />
											</colgroup>
											<tbody id="buyerPOTableBody"></tbody>
										</table>
									</div>
									<div className="col-sm-12 text-center" style={{ marginTop: 20 }}>
										<button type="button" className="btn btn-warning" onClick={this.selectBPO}>Select BPO</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default MaintainQuotes;
